module.exports = __webpack_public_path__ + "img/Cook Islands.027d5f2a.svg";